import { TableCell, TableFooter, TableRow } from '@material-ui/core';
import React from 'react';
import { floatRenderer } from '../../../services/formatSvc';

const totalCellStyle = { color: 'inherit', fontWeight: 'bold' };

export default function ProgramBuysFooter(props) {
  const currentColumns = props.columns.filter((c) => !c.hidden);
  const aggFields = currentColumns.filter((c) => c.aggregated).map((c) => c.field);
  const first = currentColumns.findIndex((c) => c.aggregated);
  const last = currentColumns.findLastIndex((c) => c.aggregated);

  const total = props.renderData
    .reduce(
      (acc, row) => {
        // eslint-disable-next-line no-return-assign
        aggFields.forEach((f) => acc[f] += (row[f] || 0)); // суммируем значения полей по всем столбцам, которые требуют итоговой суммы
        return acc;
      },
      aggFields.reduce((acc, field) => ({ ...acc, [field]: 0 }), {}),
    ); // поля первичного объекта складываются из списка полей столбцов, по которым требуется итоговая сумма

  return (
    <TableFooter style={{ position: 'sticky', bottom: '0', zIndex: 15 }}>
      <TableRow style={{ backgroundColor: '#FFF' }}>
        {props.actions && props.actions.length > 0 && <TableCell style={totalCellStyle} />}
        <TableCell style={totalCellStyle} colSpan={first}>ИТОГО</TableCell>
        {Object.keys(total)
          .map((key) => <TableCell key={key} style={totalCellStyle} colSpan={props.colSpans?.[key]}>{floatRenderer(total[key])}</TableCell>)}
        {currentColumns.length - last > 0 && <TableCell colSpan={currentColumns.length - last} />}
      </TableRow>
    </TableFooter>
  );
}
